import { Controller } from "@hotwired/stimulus"

/**
 * 可用的快速鍵 (Hotkeys):
 * 1. Cmd + Shift + F (macOS) / Ctrl + Shift + F (Windows/Linux): 切換聚焦到帶有此 controller 的元素
 * 2. / (斜線): 在非輸入狀態下，切換聚焦到帶有此 controller 的元素
 */
export default class extends Controller {
  static instances = []

  connect() {
    this.constructor.instances.push(this.element)
    
    if (this.constructor.instances.length === 1) {
      window.addEventListener("keydown", this.constructor.handleKeydown)
    }
  }

  disconnect() {
    const index = this.constructor.instances.indexOf(this.element)
    if (index > -1) {
      this.constructor.instances.splice(index, 1)
    }
    
    if (this.constructor.instances.length === 0) {
      window.removeEventListener("keydown", this.constructor.handleKeydown)
    }
  }

  static handleKeydown = (event) => {
    const isFocusHotkey = (event.metaKey || event.ctrlKey) && event.shiftKey && event.key.toLowerCase() === 'f'
    const isSlashKey = event.key === '/' && !['INPUT', 'TEXTAREA', 'SELECT'].includes(event.target.tagName) && !event.target.isContentEditable

    if (isFocusHotkey || isSlashKey) {
      event.preventDefault()
      
      const instances = this.instances
      // Sort instances by DOM order to ensure cycling makes sense visually
      instances.sort((a, b) => (a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING) ? -1 : 1)

      const activeElement = document.activeElement
      const currentIndex = instances.indexOf(activeElement)
      
      let nextIndex = 0
      if (currentIndex !== -1) {
        nextIndex = (currentIndex + 1) % instances.length
      }
      
      const nextElement = instances[nextIndex]
      if (nextElement) {
        nextElement.focus()
        // Select text if it's an input/textarea
        if (typeof nextElement.select === 'function') {
          nextElement.select()
        }
      }
    }
  }
}
